import {
  PICKUP_VALIDATION_LOAD,
  PICKUP_VALIDATION_LOAD_SUCCESS,
  PICKUP_VALIDATION_LOAD_FAILURE,
  PICKUP_VALIDATION_START,
  PICKUP_VALIDATION_START_SUCCESS,
  PICKUP_VALIDATION_START_FAILURE,
  PICKUP_VALIDATION_VERIFY,
  PICKUP_VALIDATION_VERIFY_SUCCESS,
  PICKUP_VALIDATION_VERIFY_FAILURE,
  PICKUP_VALIDATION_SUPPORT_RELEASE,
  PICKUP_VALIDATION_SUPPORT_RELEASE_SUCCESS,
  PICKUP_VALIDATION_SUPPORT_RELEASE_FAILURE,
  PICKUP_VALIDATION_RELEASE,
  PICKUP_VALIDATION_RELEASE_SUCCESS,
  PICKUP_VALIDATION_RELEASE_FAILURE,
  PICKUP_VALIDATION_CANCEL,
  PICKUP_VALIDATION_CANCEL_SUCCESS,
  PICKUP_VALIDATION_CANCEL_FAILURE,
  PICKUP_VALIDATION_UPLOAD_PHOTO,
  PICKUP_VALIDATION_UPLOAD_PHOTO_SUCCESS,
  PICKUP_VALIDATION_UPLOAD_PHOTO_FAILURE,
  PICKUP_VALIDATION_DISPATCHED_RECEIVED,
  PICKUP_VALIDATION_OPEN_MODAL,
  PICKUP_VALIDATION_CLOSE_MODAL,
  PICKUP_VALIDATION_RESET,
} from './actionsTypes';

// Load
export const loadValidationRequest = cartId => ({
  type: PICKUP_VALIDATION_LOAD,
  payload: { cartId },
});

export const loadValidationSuccess = validation => ({
  type: PICKUP_VALIDATION_LOAD_SUCCESS,
  payload: { validation },
});

export const loadValidationFailure = error => ({
  type: PICKUP_VALIDATION_LOAD_FAILURE,
  payload: { error },
});

// Start
export const startValidationRequest = cartId => ({
  type: PICKUP_VALIDATION_START,
  payload: { cartId },
});

export const startValidationSuccess = validation => ({
  type: PICKUP_VALIDATION_START_SUCCESS,
  payload: { validation },
});

export const startValidationFailure = error => ({
  type: PICKUP_VALIDATION_START_FAILURE,
  payload: { error },
});

// Verify
export const verifyValidationRequest = (cartId, data) => ({
  type: PICKUP_VALIDATION_VERIFY,
  payload: { cartId, data },
});

export const verifyValidationSuccess = validation => ({
  type: PICKUP_VALIDATION_VERIFY_SUCCESS,
  payload: { validation },
});

export const verifyValidationFailure = error => ({
  type: PICKUP_VALIDATION_VERIFY_FAILURE,
  payload: { error },
});

// Support Release
export const supportReleaseRequest = cartId => ({
  type: PICKUP_VALIDATION_SUPPORT_RELEASE,
  payload: { cartId },
});

export const supportReleaseSuccess = validation => ({
  type: PICKUP_VALIDATION_SUPPORT_RELEASE_SUCCESS,
  payload: { validation },
});

export const supportReleaseFailure = error => ({
  type: PICKUP_VALIDATION_SUPPORT_RELEASE_FAILURE,
  payload: { error },
});

// Release
export const releaseRequest = cartId => ({
  type: PICKUP_VALIDATION_RELEASE,
  payload: { cartId },
});

export const releaseSuccess = validation => ({
  type: PICKUP_VALIDATION_RELEASE_SUCCESS,
  payload: { validation },
});

export const releaseFailure = error => ({
  type: PICKUP_VALIDATION_RELEASE_FAILURE,
  payload: { error },
});

// Cancel
export const cancelValidationRequest = (cartId, reason = '') => ({
  type: PICKUP_VALIDATION_CANCEL,
  payload: { cartId, reason },
});

export const cancelValidationSuccess = validation => ({
  type: PICKUP_VALIDATION_CANCEL_SUCCESS,
  payload: { validation },
});

export const cancelValidationFailure = error => ({
  type: PICKUP_VALIDATION_CANCEL_FAILURE,
  payload: { error },
});

// Upload Photo
export const uploadPhotoRequest = (cartId, file) => ({
  type: PICKUP_VALIDATION_UPLOAD_PHOTO,
  payload: { cartId, file },
});

export const uploadPhotoSuccess = validation => ({
  type: PICKUP_VALIDATION_UPLOAD_PHOTO_SUCCESS,
  payload: { validation },
});

export const uploadPhotoFailure = error => ({
  type: PICKUP_VALIDATION_UPLOAD_PHOTO_FAILURE,
  payload: { error },
});

// Echo: entregador acionou coleta no parceiro
export const dispatchedReceived = data => ({
  type: PICKUP_VALIDATION_DISPATCHED_RECEIVED,
  payload: data,
});

// Modal
export const openValidationModal = () => ({
  type: PICKUP_VALIDATION_OPEN_MODAL,
});

export const closeValidationModal = () => ({
  type: PICKUP_VALIDATION_CLOSE_MODAL,
});

// Reset
export const resetValidation = () => ({
  type: PICKUP_VALIDATION_RESET,
});
